import { examinationEncounterWarnings, type OrderedIcd10Codes } from "./examinationEncounterCodes";
import { historyOrStatusPrimaryWarnings } from "./historyOrStatusPrimary";

/** Every per-code inline warning that is a plain function of the ordered list; no two rules warn on the same code. */
export const diagnosisCodeWarnings = (orderedIcd10Codes: OrderedIcd10Codes) => [
  ...examinationEncounterWarnings(orderedIcd10Codes),
  ...historyOrStatusPrimaryWarnings(orderedIcd10Codes),
];
